<p-toast></p-toast>

@if (vm$ | async; as vm) {
@if (vm.load; as load) {
<div class="load-details-shell fade-in">
  <section class="page-hero">
    <div class="hero-main">
      <button pButton type="button" [label]="ui('Back', 'رجوع')" (click)="goBack('/loads')"
        class="p-button-text p-button-secondary action-button icon-button back-button">
        <fa-icon [icon]="icons.back"></fa-icon>
      </button>
      <span class="eyebrow">{{ ui('Load Detail', 'تفاصيل الحمل') }}</span>
      <h1 class="hero-title">{{ routeTitle(load.originLabel || load.origin, load.destinationLabel || load.destination) }}</h1>
      <div class="hero-meta">
        <p-tag [value]="statusLabel(load.status || 'POSTED')" [severity]="load.status === 'BOOKED' ? 'success' : 'info'"
          [rounded]="true"></p-tag>
        <span class="reference-pill">{{ load.referenceNumber || ui('Load request', 'طلب حمل') }}</span>
        <span>{{ 'LOADS.DETAILS.POSTED' | translate:{date: displayDate(load.createdAt)} }}</span>
      </div>
    </div>

    <div class="hero-actions">
      <button pButton [label]="ui('WhatsApp', 'واتساب')" (click)="shareToWhatsApp()"
        class="p-button-outlined p-button-success action-button icon-button">
        <fa-icon [icon]="icons.whatsapp"></fa-icon>
      </button>
      <button pButton [label]="ui('Call', 'اتصال')" (click)="callContact()" [disabled]="!load.contactNumber"
        class="p-button-outlined p-button-secondary action-button icon-button">
        <fa-icon [icon]="icons.phone"></fa-icon>
      </button>
      <button pButton [label]="ui('Share', 'مشاركة')" (click)="shareLoad()"
        class="p-button-outlined p-button-secondary action-button icon-button">
        <fa-icon [icon]="icons.share"></fa-icon>
      </button>
      <button pButton [label]="ui('Copy', 'نسخ')" (click)="copyDetails()"
        class="p-button-outlined p-button-secondary action-button icon-button">
        <fa-icon [icon]="icons.copy"></fa-icon>
      </button>
    </div>
  </section>

  @if (load.status === 'BOOKED' && load.matches?.length) {
  <section class="state-banner booked-banner">
    <fa-icon [icon]="icons.checkCircle"></fa-icon>
    <div>
      <strong>{{ ui('This load is BOOKED', 'هذا الحمل محجوز') }}</strong>
      <div class="chips-row">
        @for (match of load.matches; track match.id) {
        <a [routerLink]="['/matches', match.id]" class="match-link">
          <span class="info-chip accent-chip">{{ ui('Match', 'مطابقة') }}: {{ match.matchNumber }}</span>
        </a>
        }
      </div>
    </div>
  </section>
  }

  <div class="grid details-grid">
    <div class="col-12 xl:col-8 panel-column">
      <section class="market-panel route-panel">
        <header class="panel-header">
          <div>
            <div class="panel-kicker"><fa-icon [icon]="icons.route"></fa-icon> {{ ui('Route Workspace', 'جدول المسار') }}</div>
            <h2>{{ 'LOADS.DETAILS.ROUTE_SCHEDULE' | translate }}</h2>
            <p>{{ ui('Pickup, delivery, route timing, and map context for this request.', 'تفاصيل الاستلام والتسليم ووقت المسار والخريطة لهذا الطلب.') }}</p>
          </div>
          <div class="header-meta">
            <span class="sort-badge">{{ displayDate(load.createdAt) }}</span>
          </div>
        </header>

        <div class="route-workspace">
          <div class="map-frame">
            <app-google-map [origin]="load.origin" [destination]="load.destination"
              (routeInfo)="onMapInfoReceived($event)"></app-google-map>
          </div>

          <div class="route-focus">
            <div class="route-marker">
              <span class="dot origin-dot"></span>
              <span class="line"></span>
              <span class="dot destination-dot"></span>
            </div>

            <div class="route-copy">
              <div class="route-stop">
                <span class="route-label"><fa-icon [icon]="icons.calendar"></fa-icon> {{ 'LOADS.DETAILS.PICKUP' | translate }}</span>
                <strong>{{ load.originLabel || load.origin }}</strong>
                <span>{{ displayDate(load.pickupDate, true) }}</span>
                @if (vm.summaryMetrics[0]?.hint) {
                <small>{{ vm.summaryMetrics[0].hint }}</small>
                }
              </div>
              <div class="route-stop">
                <span class="route-label"><fa-icon [icon]="icons.route"></fa-icon> {{ 'LOADS.DETAILS.DELIVERY' | translate }}</span>
                <strong>{{ load.destinationLabel || load.destination }}</strong>
                <span>{{ displayDate(load.deliveryDate, true) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="metrics-grid">
          @for (metric of vm.summaryMetrics; track metric.label) {
          <article class="metric-card">
            <span><fa-icon [icon]="iconForSummaryMetric(metric.label)"></fa-icon> {{ metric.label | translate }}</span>
            <strong>{{ metric.value | translate }}</strong>
            @if (metric.hint) {
            <small>{{ metric.hint | translate }}</small>
            }
          </article>
          }
        </div>
      </section>

      <section class="market-panel">
        <header class="panel-header">
          <div>
            <div class="panel-kicker"><fa-icon [icon]="icons.truck"></fa-icon> {{ ui('Freight', 'الشحنة') }}</div>
            <h2>{{ 'LOADS.DETAILS.LOAD_DETAILS' | translate }}</h2>
            <p>{{ ui('Equipment, freight dimensions, commodity, and handling requirements.', 'المعدات وأبعاد الشحنة والبضاعة ومتطلبات المناولة.') }}</p>
          </div>
        </header>

        <div class="capacity-layout">
          <div class="metrics-grid compact">
            @for (detail of vm.equipmentMetrics; track detail.label) {
            <article class="metric-card">
              <span><fa-icon [icon]="iconForEquipmentMetric(detail.label)"></fa-icon> {{ detail.label | translate }}</span>
              <strong>{{ detail.value | translate }}</strong>
            </article>
            }
          </div>

          <div class="requirements-card">
            <span class="section-label"><fa-icon [icon]="icons.listCheck"></fa-icon> {{ ui('Requirements', 'المتطلبات') }}</span>
            <div class="chips-row">
              @for (tag of vm.requirementTags; track tag) {
              <span class="info-chip accent-chip"><fa-icon [icon]="icons.checkCircle"></fa-icon>{{ tag }}</span>
              } @empty {
              <span class="info-chip"><fa-icon [icon]="icons.circleInfo"></fa-icon>{{ 'COMMON.NA' | translate }}</span>
              }
            </div>
          </div>
        </div>
      </section>

      <section class="market-panel">
        <header class="panel-header">
          <div>
            <div class="panel-kicker"><fa-icon [icon]="icons.boxOpen"></fa-icon> {{ ui('Broker Notes', 'ملاحظات الوسيط') }}</div>
            <h2>{{ 'LOADS.DETAILS.BROKER_NOTES' | translate }}</h2>
          </div>
        </header>

        @if (load.originalMessage) {
        <div class="notes-card">{{ load.originalMessage }}</div>
        } @else {
        <div class="state-block empty-state">
          <fa-icon [icon]="icons.inbox"></fa-icon>
          <span>{{ 'COMMON.NA' | translate }}</span>
        </div>
        }
      </section>
    </div>

    <div class="col-12 xl:col-4 panel-column">
      <aside class="side-stack">
        <section class="action-card rate-card">
          <span class="panel-kicker"><fa-icon [icon]="icons.invoice"></fa-icon> {{ 'LOADS.FIND.TARGET_RATE' | translate }}</span>
          <strong>{{ formatRate(load.targetRate ?? load.proposedRate, effectiveCurrencyCode(load.currencyCode)) }}</strong>
          <p>{{ ui(effectiveCurrencyCode(load.currencyCode) + ' target for this posted request.', 'السعر المستهدف لهذا الطلب المنشور.') }}</p>

          @if (load.status !== 'BOOKED') {
          <form [formGroup]="counterForm" (ngSubmit)="submitCounter()" class="counter-form">
            <p-iftaLabel class="w-full">
              <p-inputNumber inputId="counterAmount" formControlName="counterAmount" mode="currency"
                [currency]="effectiveCurrencyCode(load.currencyCode)" locale="en-US" [min]="0.01" [minFractionDigits]="0"
                [maxFractionDigits]="2" inputStyleClass="w-full" styleClass="w-full"
                class="w-full"></p-inputNumber>
              <label for="counterAmount">{{ 'LOADS.DETAILS.OFFER_AMOUNT' | translate }}</label>
            </p-iftaLabel>
            <button pButton [label]="ui('Submit Offer', 'إرسال العرض')" type="submit"
              class="w-full p-button-success action-button"></button>
          </form>
          }
        </section>

        @if (load.shipperCompanyId) {
        <section class="action-card shipper-card">
          <div class="shipper-headline">
            <span class="panel-kicker"><fa-icon [icon]="icons.userTie"></fa-icon> {{ 'LOADS.DETAILS.ABOUT_SHIPPER' | translate }}</span>
            @if (vm.company?.logo) {
            <p-avatar [image]="vm.company!.logo || undefined" shape="circle" size="xlarge"
              styleClass="shipper-avatar"></p-avatar>
            } @else {
            <p-avatar label="S" shape="circle" size="xlarge" styleClass="shipper-avatar"></p-avatar>
            }
            <h2>{{ vm.company?.name || load.clientCompanyName || ui('Shipper', 'الشاحن') }}</h2>
            @if (load.trustSummary?.company?.trustBadge) {
            <span class="info-chip accent-chip">{{ load.trustSummary?.company?.trustBadge }}</span>
            }
          </div>

          @if (vm.company?.address) {
          <div class="detail-row solo-row">
            <span><fa-icon [icon]="icons.route"></fa-icon> {{ ui('Location', 'الموقع') }}</span>
            <strong>{{ vm.company!.address }}</strong>
          </div>
          } @else if (!vm.company) {
          <div class="skeleton-stack">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
            <p-skeleton width="75%" height="1rem"></p-skeleton>
          </div>
          }
        </section>
        }

        <section class="market-panel signal-panel">
          <header class="panel-header compact-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.bolt"></fa-icon> {{ ui('Demand', 'الطلب') }}</div>
              <h2>{{ ui('Demand signals', 'مؤشرات الطلب') }}</h2>
              <p>{{ ui('Live marketplace cues for prioritizing this load.', 'مؤشرات السوق الحية لتحديد أولوية هذا الحمل.') }}</p>
            </div>
          </header>
          <div class="signal-strip">
            @for (badge of signalBadges(load); track badge.label) {
            <span class="info-chip demand-chip" [class.accent-chip]="badge.strong">
              <fa-icon [icon]="badge.icon"></fa-icon>{{ badge.label }}
            </span>
            }
          </div>
        </section>

        @if (load.trustSummary; as trust) {
        <section class="market-panel trust-panel">
          <header class="panel-header compact-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.shield"></fa-icon> {{ ui('Trust', 'الثقة') }}</div>
              <h2>{{ ui('Trust & payment confidence', 'الثقة وموثوقية الدفع') }}</h2>
              <p>{{ ui('Approved LoadGate trust profile values for driver decision support.', 'قيم ملف الثقة المعتمدة من LoadGate لدعم قرار السائق.') }}</p>
            </div>
          </header>

          <div class="trust-body">
            @if (trust.company; as companyTrust) {
            <div class="trust-headline">
              <span class="info-chip accent-chip">{{ labelize(companyTrust.trustBadge) || labelize(companyTrust.companyClass) || ui('Company profile', 'ملف الشركة') }}</span>
              @if (companyTrust.trustScore !== null && companyTrust.trustScore !== undefined) {
              <strong>{{ companyTrust.trustScore }}/100</strong>
              <small>{{ ui('Trust score', 'درجة الثقة') }}</small>
              }
            </div>
            <div class="details-list embedded-list">
              <div class="detail-row">
                <span><fa-icon [icon]="icons.checkCircle"></fa-icon> {{ ui('Verification', 'التحقق') }}</span>
                <strong>{{ labelize(companyTrust.verificationStatus) || ui('Limited history', 'سجل محدود') }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.creditCard"></fa-icon> {{ ui('Payment confidence', 'موثوقية الدفع') }}</span>
                <strong>{{ labelize(companyTrust.paymentConfidence) || ui('Limited history', 'سجل محدود') }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.shield"></fa-icon> {{ ui('LoadGate status', 'حالة LoadGate') }}</span>
                <strong>{{ labelize(companyTrust.assuranceStatus) || ui('Communication only', 'تواصل فقط') }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.listCheck"></fa-icon> {{ ui('CR verified', 'السجل التجاري موثق') }}</span>
                <strong>{{ formatTrustBoolean(companyTrust.crVerified) }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.listCheck"></fa-icon> {{ ui('VAT verified', 'ضريبة القيمة المضافة موثقة') }}</span>
                <strong>{{ formatTrustBoolean(companyTrust.vatVerified) }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.checkCircle"></fa-icon> {{ ui('Business verified', 'النشاط التجاري موثق') }}</span>
                <strong>{{ formatTrustBoolean(companyTrust.businessVerified) }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.copy"></fa-icon> {{ ui('Contract signed', 'العقد موقع') }}</span>
                <strong>{{ formatTrustBoolean(companyTrust.contractSigned) }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.creditCard"></fa-icon> {{ ui('Payment terms recorded', 'شروط الدفع مسجلة') }}</span>
                <strong>{{ formatTrustBoolean(companyTrust.paymentTermsRecorded) }}</strong>
              </div>
            </div>
            @if (companyTrust.driverRecommendationNote) {
            <div class="trust-note">{{ companyTrust.driverRecommendationNote }}</div>
            }
            }

            @if (trust.customer; as customerTrust) {
            <div class="details-list embedded-list">
              <div class="detail-row">
                <span><fa-icon [icon]="icons.userTie"></fa-icon> {{ ui('Contact role', 'دور جهة الاتصال') }}</span>
                <strong>{{ labelize(customerTrust.customerRole) || ui('Contact person', 'جهة اتصال') }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.idBadge"></fa-icon> {{ ui('Contact verification', 'تحقق جهة الاتصال') }}</span>
                <strong>{{ labelize(customerTrust.verificationStatus) || ui('Unverified', 'غير موثق') }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.checkCircle"></fa-icon> {{ ui('Mobile verified', 'الجوال موثق') }}</span>
                <strong>{{ formatTrustBoolean(customerTrust.mobileVerified) }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.idBadge"></fa-icon> {{ ui('Identity submitted', 'تم تقديم الهوية') }}</span>
                <strong>{{ formatTrustBoolean(customerTrust.identitySubmitted) }}</strong>
              </div>
              <div class="detail-row">
                <span><fa-icon [icon]="icons.listCheck"></fa-icon> {{ ui('Basic review completed', 'اكتملت المراجعة الأساسية') }}</span>
                <strong>{{ formatTrustBoolean(customerTrust.basicReviewCompleted) }}</strong>
              </div>
            </div>
            }

            <p class="trust-caution">{{ ui('Payment terms should be confirmed before trip confirmation.', 'يجب تأكيد شروط الدفع قبل تأكيد الرحلة.') }}</p>
          </div>
        </section>
        }

        <section class="action-card payment-card">
          <span class="panel-kicker"><fa-icon [icon]="icons.creditCard"></fa-icon> {{ ui('Payment Terms', 'شروط الدفع') }}</span>
          <strong>{{ vm.paymentTermsDisplay | translate }}</strong>
          <p>{{ ui('Confirm payment timing before trip confirmation.', 'أكد توقيت الدفع قبل تأكيد الرحلة.') }}</p>
        </section>

        <section class="market-panel">
          <header class="panel-header compact-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.copy"></fa-icon> {{ ui('Record', 'السجل') }}</div>
              <h2>{{ 'LOADS.DETAILS.REQ_COMPLIANCE' | translate }}</h2>
            </div>
          </header>

          <div class="details-list">
            @for (detail of vm.generalDetails; track detail.label) {
            <div class="detail-row">
              <span><fa-icon [icon]="iconForDetailRow(detail.label)"></fa-icon> {{ detail.label | translate }}</span>
              <strong>{{ detail.value | translate }}</strong>
            </div>
            }
            @for (detail of vm.complianceDetails; track detail.label) {
            <div class="detail-row">
              <span><fa-icon [icon]="iconForDetailRow(detail.label)"></fa-icon> {{ detail.label | translate }}</span>
              <strong>{{ detail.value | translate }}</strong>
            </div>
            }
          </div>
        </section>

      </aside>
    </div>
  </div>
</div>
}
} @else {
<div class="load-details-shell">
  <div class="state-block">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ ui('Loading load details...', 'جار تحميل تفاصيل الحمل...') }}</span>
  </div>
</div>
}
